import { ReactElement, ReactNode } from 'react'
import CommentDrawer from '@editor/components/CommentDrawer'
import PlanImageCardDrawer from '@editor/components/PlanImageCardDrawer'
import PlanTableDrawer from '@editor/components/PlanTableDrawer'

interface Props {
  /** The one plan element type currently selected/active, if any. */
  planElementType: 'comment' | 'image-card' | 'table' | 'element-label' | null
  /** Rendered when `planElementType` isn't one of the three drawer types. */
  fallback?: ReactNode
}

/** Picks the drawer for whichever plan element (comment / table / image card) is active. */
const PlanElementDrawer = ({ planElementType, fallback = null }: Props): ReactElement => {
  switch (planElementType) {
    case 'comment':
      return <CommentDrawer />
    case 'table':
      return <PlanTableDrawer />
    case 'image-card':
      return <PlanImageCardDrawer />
    default:
      return <>{fallback}</>
  }
}

export default PlanElementDrawer
